import React, { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import { compose } from "redux";
import {
  Button,
  Dropdown,
  Form,
  Grid,
  Popup,
  Modal,
  TextArea,
  TransitionablePortal,
} from "semantic-ui-react";
import { uid } from "uid";
import { animation, duration } from "../../../utils/utils";
import { debounce } from "lodash";
import { newReminder } from "../../../store/actions/reminderActions";
import ConfirmAdd from "./ConfirmAdd";
import { placeHolderImage } from "../EventCard";
import SportList from "../../athletes/SportList";
import ClassYearDropDown from "../ClassYearDropDown";
import ReminderFor from "./ReminderFor";
import AdvocatesReminderDropdown from "./AdvocatesReminderDropdown";
import { committedOptions } from "../../../utils/consts";

const Add = (props) => {
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [athletes, setAthletes] = useState([]);
  const [validator, setValidator] = useState(false);
  // Submission Values
  const [selectedAthletes, setSelectedAthletes] = useState([]);
  const [title, setTitle] = useState(null);
  const [content, setContent] = useState(null);
  const [all, setAll] = useState(false);
  // Filter Options
  const [sport, setSport] = useState(null);
  const [classYear, setClassYear] = useState(null);
  const [commit, setCommit] = useState(null);
  const [confirm, setConfirm] = useState(false);
  // Advocates
  const [advocates, setAdvocates] = useState(false);
  useEffect(() => {
    const saving = props.athletes;
    if (saving && saving.length > 0) {
      const tempArray = saving.map((athlete, index) => {
        return {
          key: index,
          text: `${athlete.firstName} ${athlete.lastName}`,
          value: athlete.id,
          image: {
            avatar: true,
            src:
              athlete.thumbnail &&
              athlete.thumbnail !== "None" &&
              athlete.thumbnail !== "none"
                ? athlete.thumbnail
                : placeHolderImage,
          },
        };
      });
      setAthletes(tempArray);
    }
  }, [props.athletes]);

  useEffect(() => {
    if (advocates && props.advocates) {
      if (all) {
        const allData = [];
        props.advocates.forEach((ad) => {
          const data = {
            id: ad?.id,
            email: ad?.email,
            contact1: ad?.phone || null,
            contact2: null,
            contact3: null,
          };
          allData.push(data);
        });
        setSelectedAthletes([...allData]);
      } else {
        setSelectedAthletes([]);
      }
    }
  }, [all, props.advocates, advocates]);

  useEffect(() => {
    setValidator(!(title && content && (all || selectedAthletes.length > 0)));
  }, [title, content, all, selectedAthletes.length]);

  const handleClose = () => {
    setError(null);
    setSelectedAthletes([]);
    setTitle(null);
    setContent(null);
    setAll(null);
    setConfirm(false);
    props.close();
  };

  useEffect(() => {
    if (props.added) {
      handleClose();
    }
  }, [props.added]);
  const handleSubmit = () => {
    if (validator) {
      setError("All fields are required");
    } else {
      const athleteList = () => {
        if (all && !advocates) {
          if (
            props.contactsData &&
            Object.keys(props.contactsData).length > 0 &&
            props.emailData &&
            Object.keys(props.emailData).length > 0
          ) {
            const emails = { ...props.emailData };
            const contacts = { ...props.contactsData };
            const dataToReturn = athletes.map((athlete) => {
              let athnumber = contacts[athlete]?.athleteContact;
              if (athnumber) {
                const tempArray = athnumber.split("-").join("");
                athnumber = `+1${tempArray}`;
              }

              let parnumber = contacts[athlete]?.parentsContact;
              let parnumber2 = contacts[athlete]?.parentsContact2;
              if (parnumber) {
                const tempArray = parnumber.split("-").join("");

                parnumber = `+1${tempArray}`;
              }
              if (parnumber2) {
                const tempArray = parnumber2.split("-").join("");

                parnumber2 = `+1${tempArray}`;
              }
              return {
                id: athlete.value,
                email: emails[athlete.value].email,
                contact1: contacts[athlete]?.athleteContact ? athnumber : null,
                contact2: contacts[athlete]?.parentsContact ? parnumber : null,
                contact3: contacts[athlete]?.parentsContact2
                  ? parnumber2
                  : null,
              };
            });
            return dataToReturn;
          }
        } else {
          return [...selectedAthletes];
        }
      };

      const toFireStore = {
        id: uid(8),
        title,
        content,
        athletes: athleteList(),
      };
      // console.log(toFireStore);
      dispatch(newReminder(toFireStore));
    }
  };
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    switch (name) {
      case "title":
        if (typeof value === "string" || value instanceof String) {
          setTitle(value);
        }
        break;
      case "content":
        if (typeof value === "string" || value instanceof String) {
          setContent(value);
        }
        break;
      default: {
      }
    }
  };

  const debouncedChangeHandler = useCallback(debounce(handleChange, 300), []);

  const handleDropdownChange = (e, data) => {
    if (
      props.emailData &&
      Object.keys(props.emailData).length > 0 &&
      props.contactsData &&
      Object.keys(props.contactsData).length > 0
    ) {
      const selected = [...data.value];
      const emails = { ...props.emailData };
      const contacts = { ...props.contactsData };
      const athletesWithEmail = selected.map((athlete) => {
        let athnumber = contacts[athlete]?.athleteContact;
        if (athnumber) {
          const tempArray = athnumber.split("-").join("");
          athnumber = `+1${tempArray}`;
        }

        let parnumber = contacts[athlete]?.parentsContact;
        if (parnumber) {
          const tempArray = parnumber.split("-").join("");

          parnumber = `+1${tempArray}`;
        }
        let parnumber2 = contacts[athlete]?.parentsContact2;
        if (parnumber2) {
          const tempArray = parnumber2.split("-").join("");

          parnumber2 = `+1${tempArray}`;
        }

        return {
          id: athlete,
          email: emails[athlete].email,
          contact1: contacts[athlete]?.athleteContact ? athnumber : null,
          contact2: contacts[athlete]?.parentsContact ? parnumber : null,
          contact3: contacts[athlete]?.parentsContact2 ? parnumber2 : null,
        };
      });
      setSelectedAthletes([...athletesWithEmail]);
    }
  };
  const athleteContactData = (givenArray) => {
    const emails = { ...props.emailData };
    const contacts = { ...props.contactsData };
    const savingArray = givenArray.map((athlete) => {
      let athnumber = contacts[athlete]?.athleteContact;
      if (athnumber) {
        const tempArray = athnumber.split("-").join("");
        athnumber = `+1${tempArray}`;
      }

      let parnumber = contacts[athlete]?.parentsContact;
      if (parnumber) {
        const tempArray = parnumber.split("-").join("");

        parnumber = `+1${tempArray}`;
      }
      let parnumber2 = contacts[athlete]?.parentsContact2;
      if (parnumber2) {
        const tempArray = parnumber2.split("-").join("");

        parnumber2 = `+1${tempArray}`;
      }

      return {
        id: athlete,
        email: emails[athlete].email,
        contact1: contacts[athlete]?.athleteContact ? athnumber : null,
        contact2: contacts[athlete]?.parentsContact ? parnumber : null,
        contact3: contacts[athlete]?.parentsContact2 ? parnumber2 : null,
      };
    });
    return savingArray;
  };
  const handleFilterDropDown = (name, value) => {
    switch (name) {
      case "sportDropdown":
        if (!value) {
          setSelectedAthletes([]);
        }
        setSport(value);
        break;
      case "classDropdown":
        if (!value) {
          setSelectedAthletes([]);
        }
        setClassYear(value);
        break;
      case "committedDropdown":
        if (value === "") {
          setSelectedAthletes([]);
        }
        setCommit(value);
        break;

      default:
        break;
    }
  };
  useEffect(() => {
    if (
      props.athletes &&
      (sport || classYear || commit === false || commit === true)
    ) {
      const saving = props.athletes;
      let athletesWithEmail = [];
      if (classYear) {
        if (athletesWithEmail.length > 0) {
          athletesWithEmail = athletesWithEmail.map((athlete) => {
            if (athlete?.class === classYear) {
              return athlete;
            } else {
              return null;
            }
          });
        } else {
          athletesWithEmail = saving.map((athlete) => {
            if (athlete?.class === classYear) {
              return athlete;
            } else {
              return null;
            }
          });
        }
      }
      if (sport) {
        if (athletesWithEmail.length > 0) {
          athletesWithEmail = athletesWithEmail.map((athlete) => {
            if (athlete?.sport === sport) {
              return athlete;
            } else {
              return null;
            }
          });
        } else {
          athletesWithEmail = saving.map((athlete) => {
            if (athlete?.sport === sport) {
              return athlete;
            } else {
              return null;
            }
          });
        }
      }
      if (commit === false || commit === true) {
        if (athletesWithEmail.length > 0) {
          athletesWithEmail = athletesWithEmail.map((athlete) => {
            if (athlete?.committed === commit) {
              return athlete;
            } else {
              return null;
            }
          });
        } else {
          athletesWithEmail = saving.map((athlete) => {
            if (athlete?.committed === commit) {
              return athlete;
            } else {
              return null;
            }
          });
        }
      }
      athletesWithEmail = athletesWithEmail.filter((e) => e).map((e) => e.id);
      if (athletesWithEmail.length > 0) {
        athletesWithEmail = athleteContactData(athletesWithEmail);
      }

      setSelectedAthletes([...athletesWithEmail]);
    }
  }, [props.athletes, classYear, sport, commit]);
  return (
    <>
      <TransitionablePortal
        transition={{ animation, duration }}
        onClose={handleClose}
        open={props.open}
      >
        <Modal
          size="tiny"
          closeIcon
          className="cu-event-modal"
          onClose={handleClose}
          open={true}
        >
          <Modal.Content scrolling>
            <div className="AdminTopButtonsProgressContainer">
              <div className="AdminTopButtonsContainer">
                {selectedAthletes.length < 1 ? (
                  <Button
                    floated="left"
                    circular
                    active={all}
                    toggle
                    content="All"
                    onClick={() => setAll(!all)}
                  />
                ) : (
                  <Popup
                    content={`${selectedAthletes.length} ${
                      !advocates
                        ? `athlete${selectedAthletes.length > 1 ? "s" : ""}`
                        : `advocate${selectedAthletes.length > 1 ? "s" : ""}`
                    } ${selectedAthletes.length > 1 ? "are" : "is"} selected`}
                    trigger={
                      <Button
                        floated="left"
                        circular
                        positive
                        content={selectedAthletes.length}
                        onClick={() => {}}
                      />
                    }
                  />
                )}

                <Button
                  disabled={validator || error}
                  loading={props.adding}
                  floated="right"
                  positive={!validator || !error}
                  negative={validator || error}
                  name="saveButton"
                  content="Save"
                  labelPosition="right"
                  icon="checkmark"
                  onClick={() => setConfirm(true)}
                />
              </div>
              {error && <p style={{ color: "#800000" }}>{error}</p>}
              {props.newPartnerAddError && (
                <p style={{ color: "#800000" }}>
                  {props.newPartnerAddError.message}
                </p>
              )}
            </div>
            <ReminderFor
              on={(e) => {
                setAdvocates(e);
                setSelectedAthletes([]);
                setAll(false);
              }}
              current={advocates}
            />
            <Form>
              <div className="AdminFormEventContainer add-partner-modal">
                <h3>New Reminder</h3>
                <Grid divided="vertically">
                  <Grid.Row stackable="true">
                    {!all && (
                      <>
                        {/* {!selectedAthletes.length > 0 && ( */}
                        <Grid.Column mobile={16} tablet={16} computer={16}>
                          <Form.Field required>
                            <label>
                              {advocates ? "Advocates" : "Athletes"}
                            </label>
                            {!advocates ? (
                              <Dropdown
                                onChange={handleDropdownChange}
                                options={athletes}
                                search
                                clearable
                                multiple
                                loading={!isLoaded(props.athletes)}
                                placeholder="Select Athletes"
                                name="athletes"
                                selection
                                fluid
                              />
                            ) : (
                              <AdvocatesReminderDropdown
                                on={advocates}
                                onChange={(e) => setSelectedAthletes([...e])}
                                all={all}
                              />
                            )}
                          </Form.Field>
                        </Grid.Column>
                        {!advocates && (
                          <Grid.Column mobile={16} tablet={16} computer={16}>
                            <Grid divided="vertically">
                              <Grid.Row
                                style={{ paddingBottom: 0 }}
                                stackable="true"
                                columns={3}
                                className="ReminderThreeRow"
                              >
                                <Grid.Column
                                  mobile={16}
                                  tablet={5}
                                  computer={5}
                                >
                                  <Form.Field>
                                    <label>Sport</label>
                                    <SportList
                                      clearable
                                      onChange={(e, data) =>
                                        handleFilterDropDown(
                                          data.name,
                                          data.value
                                        )
                                      }
                                      name="sportDropdown"
                                      placeholder="Sport"
                                    />
                                  </Form.Field>
                                </Grid.Column>
                                <Grid.Column
                                  mobile={16}
                                  tablet={5}
                                  computer={5}
                                >
                                  <Form.Field>
                                    <label>Classyear</label>
                                    <ClassYearDropDown
                                      clearable
                                      selection
                                      fluid
                                      admin={true}
                                      placeholder="Class"
                                      name="classDropdown"
                                      onChange={(e, data) =>
                                        handleFilterDropDown(
                                          data.name,
                                          data.value
                                        )
                                      }
                                    />
                                  </Form.Field>
                                </Grid.Column>
                                <Grid.Column
                                  mobile={16}
                                  tablet={5}
                                  computer={5}
                                >
                                  <Form.Field>
                                    <label>Committed</label>
                                    <Dropdown
                                      clearable
                                      options={committedOptions}
                                      selection
                                      fluid
                                      placeholder="Committed"
                                      name="committedDropdown"
                                      onChange={(e, data) =>
                                        handleFilterDropDown(
                                          data.name,
                                          data.value
                                        )
                                      }
                                    />
                                  </Form.Field>
                                </Grid.Column>
                              </Grid.Row>
                            </Grid>
                          </Grid.Column>
                        )}
                      </>
                    )}
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                      <Form.Field required>
                        <label>Title</label>
                        <input
                          placeholder="Enter Title"
                          id="event_url"
                          name="title"
                          onChange={debouncedChangeHandler}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                      <Form.Field required>
                        <label>Content</label>
                        <TextArea
                          className="cu-textarea"
                          placeholder="Enter Content"
                          name="content"
                          onChange={debouncedChangeHandler}
                        />
                      </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </Form>
          </Modal.Content>
          {confirm && (
            <ConfirmAdd
              all={all}
              length={selectedAthletes.length}
              open={confirm}
              close={() => setConfirm(false)}
              confirm={handleSubmit}
              advocates={advocates}
            />
          )}
        </Modal>
      </TransitionablePortal>
    </>
  );
};
const mapStateToProps = (state) => {
  const advocatesData = state.firestore.ordered.advocates;
  const advocates = [];

  if (advocatesData && advocatesData.length > 0) {
    advocatesData.forEach((a) => {
      const data = {};
      data.id = a.id;
      data.name = a.name;
      data.email = a.email;
      if (a.phone) data.phone = a.phone;
      data.thumbnail = a.thumbnailUrl;

      advocates.push(data);
    });
  }
  return {
    advocates,
    contactsData: state.firestore.data.athleteContacts,
    athletes: state.firestore.ordered.adminAthletes,
    emailData: state.firestore.data.users,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
    newRequests: state.firestore.ordered.testNewRequests,
    adding: state.reminder.adding,
    error: state.reminder.error,
    added: state.reminder.add,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      {
        collection: "adminAthletes",
        where: ["profilePublic", "==", true],
        orderBy: ["lastName", "asc"],
      },
      {
        collection: "users",
        where: ["email", "!=", ""],
      },
      {
        collection: "athleteContacts",
        // where: ["athleteContact", "!=", null],
      },
      { collection: "advocates", orderBy: ["name"] },
    ];
    return firestoreArray;
  })
)(Add);
